import React from "react";

const ToolDocumentation = () => {
    return (
        <div>
            <h2>Tool Documentation</h2>
            <ol>
                <li>
                    <strong>Browser Extension</strong><br />
                    The decision to implement a browser extension was made to capture the user journey map and images, including pop-ups and notifications that may not be captured by automated crawlers. This enhances transparency and accountability by providing a comprehensive view of the user experience.
                </li>
                <li>
                    <strong>Collecting user journeys in browser extension</strong><br />
                    Capturing user journeys within a browser extension is essential for effective deceptive design detection. It enables contextual image capture, linking visuals to user actions and interactions, thus providing robust evidence of manipulation. This approach allows for the tracking of dynamic elements and offers a comprehensive, holistic view of website designs, facilitating the identification of subtle deceptive patterns. Moreover, recording user journeys enables the replication of scenarios for analysis and algorithm improvement, ensuring the detection tool's accuracy and adaptability.
                </li>
                <li>
                    <strong>Collecting information on what the user is looking for</strong><br />
                    We added an option to capturing “what is user is looking for “ as part of the browser extension. Capturing "what the user is looking for" during image capture provides crucial context for deceptive design detection. This user-intent data enables the agents to prioritize relevant image regions in the visuals. Understanding user goals helps distinguish between standard designs and manipulative cues.Correlating user intent with visual features enhances detection accuracy by focusing on elements impacting user decision-making.
                </li>
                <li>
                    <strong>Screen Capture with Selenium and Screen Capture Browser API</strong><br />
                    Selenium and the Screen Capture Browser API were chosen for cpturing images using the browser extension due to their low latency, ability to handle multiple actions simultaneously, and efficient performance.
                </li>
                <li>
                    <strong>Google Cloud</strong><br />
                    Google Cloud was selected as the storage and
                    deployment platform for the application due to its free credit
                    offering, which supports app operations and reduces additional
                    activities. It was chosen over Azure for its convenience and ease of
                    use. The Google Cloud account is currently linked
                    to app@amurabi.eu. A bucket is created for
                    the project, and data is stored under the session name to ensure
                    privacy and data protection.
                </li>
                <li>
                    <strong>Generating Public URLs of Images</strong><br />
                    o reduce the load on the
                    GPU, an automated process was implemented to generate public
                    URLs for each image captured using the browser extension. This
                    enables GPU processing to handle URLs instead of images,
                    improving scalability, performance, and storage efficiency.
                </li>
                <li>
                    <strong>API Selection (Google/ OpenAI)</strong><br />
                    The OpenAI GPT 4-o mini was
                    used for most tasks, while Google Gemini 1.5 Flash and Google
                    Gemini 2 flash were used as alternatives. We leveraged omniparser,
                    a model built on understanding AI as a model in select areas
                    specifically for UI assessment.
                </li>
                <li>
                    <strong>JSON Structure</strong><br />
                    The decision to use a JSON structure was made
                    to capture and organize information related to each aspect of work
                    within a specific node. This allows for effective content
                    enhancement and organization for experts or customers.
                </li>
                <li>
                    <strong>Transition from Streamlit to React</strong><br />
                    Streamlit was found
                    insufficient for integrating multiple libraries and features.
                    Therefore, the project transitioned to React for a more robust and
                    expandable solution, leveraging D3 visualization and other
                    necessary libraries. The chrome extension was also re-built on
                    react to enable seamless functionality and address any bugs
                    contributed by earlier HTML architecture.
                </li>
                <li>
                    <strong>D3 Library</strong><br />
                    The D3 data visualization library was chosen for
                    visualizing JSON data in a tree form due to its visual appeal, ease
                    of adoption, and community support. It provides numerous
                    transformations and visualizations, enabling future project
                    expansion.
                </li>
                <li>
                    <strong>React</strong><br />
                    React was chosen to facilitate the integration of D3
                    and the JSON editor, providing improved functionality and
                    flexibility compared to Streamlit.
                </li>
                <li>
                    <strong>Validators</strong><br />
                    Validators were implemented for descriptions
                    and agents to ensure accuracy and capture nuanced information.
                    The maker-checker model ensures comprehensive checks and
                    validations. Validators have been applied across the agentic
                    pipeline.
                </li>
                <li>
                    <strong>Filters</strong><br />
                    Filters are used to help model analyze the outcomes
                    and limit potential hallucinations. This analysis requires rigorous
                    validation of design critiques by demanding concrete evidence,
                    moving beyond assumptions. It necessitates the use of objective
                    language, avoiding ambiguous interpretations and speculative
                    claims. Contextual user experience, including cancellation
                    processes and user awareness, must be thoroughly considered.
                    Critiques should focus on specific, well-supported issues with clear
                    examples, rather than overgeneralizations, and assess the actual
                    impact on user experience, not just perceived problems. Finally,
                    actionable recommendations for improvement are essential,
                    ensuring clarity and avoiding unnecessary complexity.
                </li>
                <li>
                    <strong>Agentic Prompting Approach</strong><br />
                    To create multimodal agents
                    capable of detecting deceptive design, prompts were structured
                    using a Situation, Task, Example, Counter-Example, Analysis
                    Process, and Expected Outcome framework. This systematic
                    approach ensured each agent clearly understood its role and
                    objectives within the deceptive design detection process. By
                    providing explicit examples and counterexamples, agents were
                    trained to distinguish between standard practices and misleading
                    tactics. This structured prompting enabled a consistent and reliable
                    methodology for driving agent actions in identifying deceptive
                    design elements across multiple modalities. The analysis process
                    outlined within the prompt guided the agent through a logical
                    sequence of steps, culminating in a clearly defined expected
                    outcome, thereby enhancing the precision and effectiveness of the
                    detection.
                </li>
                <li>
                    <strong>Adoption of Airtable</strong><br />
                    For our deceptive design detection
                    tool, we transitioned prompt management from Excel to Airtable to
                    enhance reliability and leverage relational database capabilities.
                    This shift enables robust data organization and facilitates dynamic
                    updates to prompts, agent configurations, and corresponding
                    recommendation libraries. The relational structure within Airtable
                    ensures data integrity and consistency, crucial for accurate
                    deceptive pattern recognition. This move streamlines the
                    maintenance and evolution of our detection algorithms, allowing
                    for rapid adaptation to emerging deceptive design techniques.
                    Ultimately, the adoption of Airtable provides a more scalable and
                    adaptable foundation for our tool's continuous improvement.
                </li>
                <li>
                    <strong>Images stored along with user journeys</strong><br />
                    Storing captured
                    images alongside user journeys on GCP Firebase is essential for a
                    comprehensive deceptive design detector. This pairing allows for a
                    clear, visual reconstruction of the user's experience, linking specific
                    images to the sequence of actions that led to their capture. By
                    providing a synchronized view of visual data and user interactions,
                    the detector facilitates easier analysis and understanding of how
                    deceptive design elements impact user behavior. This integrated
                    storage system enables researchers and developers to quickly
                    identify patterns and refine detection algorithms, ultimately
                    improving the tool's effectiveness
                </li>
                <li>
                    <strong>Initiating agentic process on image capture</strong><br />
                    Agentic
                    process is kicked off automatically the moment image is captured
                    on browser extension. Initiating the multimodal agentic process
                    immediately upon image capture ensures rapid analysis and
                    detection of deceptive designs. This process orchestrates over 70
                    agentic actions, enabling a thorough examination of visual and
                    contextual data. By running a diverse set of agents at the
                    background, the system identifies key exceptions and potential
                    deceptive patterns within the image, providing a comprehensive
                    assessment.
                </li>
                <li>
                    <strong>Stages of agentic process</strong><br />
                    The deceptive design detection
                    process follows a four-tiered agentic approach for comprehensive
                    analysis. It begins with Contextual Analysis, where agents gather
                    essential information such as website briefs, user journeys, design
                    elements, and user focus to establish a foundation for identifying
                    deceptive patterns. Next, Preliminary Scanning utilizes two
                    scanners—one based on a static list of identifiers and another
                    leveraging LLM-generated potential deceptive designs—to provide
                    an initial assessment and guide subsequent agent actions. In the
                    Categorical Agent Deployment stage, agents are structured into
                    parent categories (Coercing, Falsification, Misdirection,
                    Obstructing, Sneaking, Omitting) and their respective child
                    categories, each targeting specific deceptive tactics. Finally, the
                    Extraction and Synthesis phase involves extracting key findings,
                    assessing harm, validating agent outputs, consolidating dark
                    patterns, retrieving factual image data, and classifying each dark
                    pattern’s certainty level (outcome, hallucination, doubtfulness)
                    before assigning it a name.
                </li>
                <li>
                    <strong>Contextual analysis choices</strong><br />
                    Gathering comprehensive
                    contextual information—including website briefs, website page
                    information, user journeys, and design elements like typography
                    and color—is essential for accurate deceptive design detection.
                    This multi-faceted approach ensures agents understand the user's
                    experience and the website's intent, preventing misinterpretations.
                    By considering the user's focus and call-to-action elements, the
                    system can identify subtle manipulations that might be missed with
                    isolated image analysis. This holistic contextualization significantly
                    improves the precision of the detection process, allowing agents to
                    differentiate between standard design practices and genuinely
                    deceptive tactics
                </li>
                <li>
                    <strong>Layered scanning for agent guidance</strong><br />
                    Employing a two-
                    tiered scanning mechanism streamlines the agentic process by
                    providing crucial preliminary insights. The static list scanner, based
                    on established research, quickly flags known deceptive identifiers,
                    while the LLM-driven scanner leverages website briefs to
                    anticipate potential deceptive designs. Combining these scanner
                    outputs allows the system to efficiently categorize and prioritize
                    areas for deeper agent analysis. This approach ensures that agents
                    focus on the most relevant aspects of the image, minimizing
                    unnecessary processing and maximizing detection efficiency. By
                    guiding the agents with pre-identified potential deceptive patterns,
                    the detector is able to quickly narrow down the search space.
                </li>
                <li>
                    <strong>Categorized Agentic Approach</strong><br />
                    Structuring the agentic process around parent
                    categories (Coercing, Falsification, Misdirection, Obstructing,
                    Sneaking, Omitting) and their child categories ensures a systematic
                    and thorough examination of potential deceptive designs. Each
                    parent category represents a distinct form of manipulation, while
                    child categories address specific tactics within those broader areas.
                    This hierarchical structure enables the agents to identify a wide
                    range of deceptive patterns, from subtle nudges to overt
                    misrepresentations. By assigning specialized agents to each
                    category, the system achieves comprehensive coverage, minimizing
                    the risk of overlooking critical deceptive elements
                </li>
                <li>
                    <strong>Extraction and synthesis of the agent outcomes</strong><br />
                    The
                    extraction and synthesis phase is crucial for transforming raw
                    agent outputs into reliable and actionable insights. This stage
                    involves extracting key highlights, assessing the potential harm,
                    and applying rigorous validation and filtering techniques. By
                    consolidating agent outcomes and fetching factual information
                    from the image, the system ensures that identified dark patterns
                    are grounded in evidence. Classifying each pattern as "outcome,"
                    "hallucination," or "doubtful" provides transparency and allows for
                    nuanced interpretation of the results. This robust validation
                    process ensures the accuracy and reliability of the deceptive design
                    detection, culminating in clear and defensible identification of dark
                    patterns
                </li>
                <li>
                    <strong>Customizing agent prompts</strong><br />
                    Agent prompts have static
                    guidance based on airtable information. For example, a
                    preselection agent will provide generic guidance to identify
                    preselection issues in the image. However, these guidance are not
                    specific. To enable these guidance to be customized to the webpage
                    and website, we have realigned the prompts through a
                    customization process. The process takes into account the static
                    agent prompts from airtable and rephrases them in the context of
                    webpage, website brief and 'what the user is looking for' to enable
                    specific approaches in which the agents can examine the image
                    instead of the generic one. Such dynamic approach enables that
                    the agents are trained to examine images uniquely based on
                    context.
                </li>
                <li>
                    <strong>Endpoints</strong><br />
                    Each agent and generation activity is assigned an endpoint to streamline the process, including regeneration of content.
                </li>
                <li>
                    <strong>Regeneration</strong><br />
                    Users have the option to regenerate certain content through created endpoints. Fresh outputs replace the existing content within the JSON node.
                </li>
                <li>
                    <strong>Auto-save Feature in JSON</strong><br />
                    An auto-save functionality is built into the JSON structure to prevent data loss. User actions are saved automatically and updated on Google Cloud upon session closure.
                </li>
                <li>
                    <strong>Feedback</strong><br />
                    We have provided an option for the user to
                    change, based on their review any outcome into hallucination or
                    doubtfulness or viceversa. Such approach allows to gather user
                    feedback thereby enabling automated feedback loop for similar
                    images in the future. Also, we have provided a text box for the user
                    to provide textual feedback and realign outcomes accordingly. The
                    textual feedback and the associated changes, along with original
                    generation are all saved to enable effective analysis and feeback
                    management at the backend.
                </li>
                <li>
                    <strong>Optimization</strong><br />
                    Several optimization attempts were made,
                    including exploring vLLM, Groq API, smaller models, and Flash
                    Attention 3 for better performance
                </li>
                <li>
                    <strong>Failures Faced</strong><br />
                    Various failures were encountered during development,
                    and alternative solutions were implemented to overcome these
                    challenges
                </li>
                <li>
                    <strong>Deployment (Vercel)</strong><br />
                    Vercel was chosen for deployment due
                    to its one-click deployment process, but the application can be
                    moved to Google Cloud if needed</li>
            </ol>
        </div>
    );
};

export default ToolDocumentation;
